import { render, staticRenderFns } from "./SpecificationPartBulkImport.vue?vue&type=template&id=49887ab2"
import script from "./SpecificationPartBulkImport.vue?vue&type=script&lang=js"
export * from "./SpecificationPartBulkImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports